/** Query keys are order-insensitive; repeated values retain their original order. */
export function canonicalBrowserSearch(
  search: string,
  ignoredKeys: ReadonlyArray<string> = []
): string {
  const params = new URLSearchParams(search)
  for (const key of ignoredKeys) {
    params.delete(key)
  }
  params.sort()
  return params.toString()
}
